import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersIndexComponent } from './containers/users/users-index/users-index.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromUsers from './+state/users/users.reducer';
import { UsersEffects } from './+state/users/users.effects';
import { UsersFacade } from './+state/users/users.facade';
import { UiModule } from '@boma/ui';
import { UsersRolesIndexComponent } from './containers/users-roles/users-roles-index/users-roles-index.component';
import * as fromRoles from './+state/roles/roles.reducer';
import { RolesEffects } from './+state/roles/roles.effects';
import { RolesFacade } from './+state/roles/roles.facade';
import { UsersDetailComponent } from './containers/users/users-detail/users-detail.component';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      { path: '', pathMatch: 'full', component: UsersIndexComponent },
      { path: 'user/:id', component: UsersDetailComponent },
      { path: 'roles', component: UsersRolesIndexComponent },
    ]),
    StoreModule.forFeature(fromUsers.USERS_FEATURE_KEY, fromUsers.UsersReducer),
    EffectsModule.forFeature([UsersEffects]),
    StoreModule.forFeature(fromRoles.ROLES_FEATURE_KEY, fromRoles.RoleReducer),
    EffectsModule.forFeature([RolesEffects]),
  ],
  declarations: [
    UsersIndexComponent,
    UsersRolesIndexComponent,
    UsersDetailComponent,
  ],
  providers: [UsersFacade, RolesFacade],
})
export class AdministrationPortalUsersModule {}
